module.exports = __webpack_public_path__ + "media/Aria_Floodlight_Installation_Steps-1-3.a9c0c8ff.mp4";